import { useLocale } from "next-intl";

import { FavoriteLeaguesQueryKeys } from "@/tanstackQuery/queries/leaguesNew";
import { addFavoriteLeague, deleteFavoriteLeague } from "@/api/leaguesNew";
import { useToggleMutation } from "../hooks";

import { League } from "@/types/ApiResponses/League";

export const useToggleFavoriteLeague = () => {
  const locale = useLocale();
  return useToggleMutation<League>({
    queryKey: [FavoriteLeaguesQueryKeys.All, locale],
    addMutationFn: addFavoriteLeague,
    deleteMutationFn: deleteFavoriteLeague,
    getSelectionKey: (item) => item.id,
    updateOptions: { preventRefetchOnSettled: true },
  });
};
